import {
  recipeMapper,
  productMapper,
  unitMapper,
  preparationSlipMappers,
  tillMapper,
  saleMapper,
  deliverySlipMappers,
  inventoryMappers,
  utilMappers
} from "./module";

const mappers = {
  ...recipeMapper,
  ...productMapper,
  ...unitMapper,
  ...preparationSlipMappers,
  ...tillMapper,
  ...saleMapper,
  ...deliverySlipMappers,
  ...inventoryMappers,
  ...utilMappers
};

export { mappers };
